import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Import fonts (latin subset only — UI is English-only, so we drop
// cyrillic/cyrillic-ext/greek/latin-ext/vietnamese woff2 files and their
// @font-face declarations, which the all-subsets variants pull in).
import '@fontsource/libre-baskerville/latin-400.css';
import '@fontsource/libre-baskerville/latin-700.css';
import '@fontsource/manrope/latin-400.css';
import '@fontsource/manrope/latin-500.css';
import '@fontsource/manrope/latin-600.css';
import '@fontsource/jetbrains-mono/latin-400.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
